export default "__VITE_ASSET__b5d3f48f__"